TextsManager = xClass("TextsManager")

var _instance = null
var loadStatus = {
    "loading" : 1,
    "success" : 2,
    "error"   : 3
}
TextsManager.defaultSentence = {
    textId: "other_02",
    title:"消灭一对是一对",
    content:"开心消消乐出续作了，还不用下载，速来~",
    img:"https://statich5clover.happyelements.com/resource/share/icon/huanxiong_1.jpg",
    bg:CLIENT_ASSETS_PUBLIC_PATH + "resource/share/bg/bg_2.png"
}
TextsManager.defaultSentenceList = table();
table.insert(TextsManager.defaultSentenceList, {
    textId: "other_02",
    title:"消灭一对是一对",
    content:"开心消消乐出续作了，还不用下载，速来~",
    img:"https://statich5clover.happyelements.com/resource/share/icon/huanxiong_1.jpg",
    bg:CLIENT_ASSETS_PUBLIC_PATH + "resource/share/bg/bg_2.png"
})
TextsManager.getInstance = function () {
    if (!_instance) {
        _instance = TextsManager.new()
        _instance.init()
    }
    return _instance
}
TextsManager.prototype.init = function () {
    var self =this
    self.status = loadStatus.loading
    self.create()
}
TextsManager.prototype.load = function () {
    var self = this
    return new Promise((resolve,reject)=>{
        self.status = loadStatus.loading // loading
        CfgManager.load("strings","share_group","share_default").then( (dataMap)=>{
                let stringsData = dataMap.get("strings");
                let shareGroupData = dataMap.get("share_group");
                let shareDefaultData = dataMap.get("share_default");
                
                let texts = {}
                for (const key in stringsData) {
                    if (stringsData.hasOwnProperty(key)) {
                        let t = stringsData[key]["value"];
                        texts[key] = t.replace(/\\n/g, "\n")
                    }
                }
                if (window.mini && window.mini.getPlatform() == MiniPlatform.wechatGame) {//微信小游戏使用安全url
                    for (const groupName in shareGroupData) {
                        if (shareGroupData.hasOwnProperty(groupName)) {
                            const group = shareGroupData[groupName];
                            for (let i = 0; i < group.length; i++) {
                                const shareData = group[i];
                                if (shareData["safe_bg"] && shareData["safe_bg"] != "") {
                                    shareData["bg"] = shareData["safe_bg"]
                                }
                            }
                        }
                    }
                }
    
                let res = Object.assign({"texts": texts , "sentenceMap": shareGroupData} , shareDefaultData)
                self.status = loadStatus.success
                self.initConfig({data: $table(res, false)})//为了兼容旧的逻辑，转换为luatable序号从1开始...
                CfgManager.release("strings","share_group","share_default")
                resolve()
            }
        ).catch((err) => {
            self.status = loadStatus.error
            console.warn(err)
            reject(err)
        })

        if (window.mini && window.mini.getPlatform() == MiniPlatform.tt){
            CfgManager.load("game").then( (dataMap)=>{
                var gameConfig = dataMap.get("game");
                self.ttShareGroup = gameConfig.douyin_share_group;
            });
        }
    })
    
}

TextsManager.prototype.create = function () {
    var self = this
    self.sentenceMap = table();
    self.defaultTitles = table();
    self.defaultImgs = table();
    self.defaultBgs = table();
    self.ttShareGroup = table();
}

TextsManager.prototype.initConfig = function (data) {
    var self = this
    let res = data.data || table()
    self.sentenceMap = res.sentenceMap || table();
    self.defaultTitles = res.defaultTitles || table();
    self.defaultImgs = res.defaultImgs || table();
    self.defaultBgs = res.defaultBgs || table();
    self.texts = res.texts || {}
    he.Localization.init(self.texts)
}

TextsManager.prototype.getText = function(key) {
    var self = this
    return self.texts[key]
}

TextsManager.prototype.getTextsListByType = function(type, defaultType) {
    var self = this
    return self.sentenceMap[type] || self.sentenceMap[defaultType] || TextsManager.defaultSentenceList;
}

/**
 * 通过分享类型与分享文本编号获取分享数据
 * @param type
 * @param textId
 */
TextsManager.prototype.getShareDataByTypeAndTextId = function(type, textId) {
    var self = this

    if (self.sentenceMap[type]) {
        for (let item in self.sentenceMap[type]) {
            if (self.sentenceMap[type][item].textId === textId) {
                return self.sentenceMap[type][item]
            }
        }
    }
    return TextsManager.defaultSentence
}

// /**
//  * 通过分享类型与选定的一组分享文本编号获取分享文本
//  * @param type
//  * @param textIds 选定的一组文本编号
//  */
// TextsManager.prototype.getRandomTextsInSelectedTextIds = function(type, textIds) {
//     var self = this

//     if (textIds && textIds.length > 0){
//         if (self.sentenceMap[type]) {
//             var textId = textIds[Math.ceil(Math.random()*3) - 1];
//             for (let item in self.sentenceMap[type]) {
//                 if (self.sentenceMap[type][item].textId === textId) {
//                     return self.sentenceMap[type][item]
//                 }
//             }
//         }
//         return TextsManager.defaultSentence
//     }else{
//         return self.getRandomTexts(type);
//     }
// }

TextsManager.prototype.getRandomTexts = function(type, defaultType) {
    var self = this
    let textList = self.getTextsListByType(type, defaultType);
    let len = $len(textList);
    // 暂时修复enable会略过分享组最后一条的bug；等配置不再导出enable = 0的内容后，这里的判断可以删除
    for(var i = len; i >= 1; i--){
        if (textList[i].enable == 0){
            table.remove(textList, i);
        }
    }
    len = $len(textList);
    if (len > 0) {
        if (window.mini && mini.getPlatform() == MiniPlatform.tt){
            // 抖音每个分享组里只会配一条带模板id的
            for (var i = 1; i <= len; i++){
                if (textList[i].douyin_share_id){
                    var t = textList[i];
                    t.title = t.douyin_share_id;
                    t.content = t.douyin_share_id;
                    return t;
                }
            }
            // 分享组里没有配模板id就随机一条模板id
            len = $len(self.ttShareGroup);
            let shareId = self.ttShareGroup[Math.floor(Math.random() * (len))];
            console.log("shareId", shareId)
            if(!shareId) {
                shareId = "1gk00lge9b8l43cs1m"
            }
            var shareText = {title:shareId, textId:shareId, content:shareId, douyin_share_id:shareId};
            return shareText;
        }
        let text = textList[Math.floor(Math.random() * (len))+1]
        if(!text || !text.textId || !text.content) {
            return TextsManager.defaultSentence
        }
        let titleLen = $len(self.defaultTitles)
        let imgLen = $len(self.defaultImgs)
        let bgLen = $len(self.defaultBgs)
        text.title = text.title || self.defaultTitles[Math.ceil(Math.random() * titleLen)]
        text.img = text.img || self.defaultImgs[Math.ceil(Math.random() * imgLen)]
        text.bg = text.bg || self.defaultBgs[Math.ceil(Math.random() * bgLen)]
        if (window.mini && mini.getPlatform() == MiniPlatform.tt){
            text.title = text.douyin_share_id; // 抖音里这是分享模板id
        }
        return text;
    } else {
        return TextsManager.defaultSentence
    }
}

TextsManager.getInstance()